"use client";
import * as React from "react";

import { cn } from "../../lib/utils";

function Label({ className, ...props }: React.ComponentProps<"label">) {
  return (
    <label
      data-slot="label"
      className={cn(
        "flex select-none items-center gap-2 text-sm font-medium leading-none text-foreground [data-disabled=true]_&:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

export { Label };
